export const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:3000";

export const API_ENDPOINTS = {
  HEALTH: "/qms/api/v1/health",
  AUTH: {
    SIGN_IN: "/qms/api/v1/user/sign-in",
    SIGN_UP: "/qms/api/v1/user/complete-signup",
    VALIDATE_SIGN_UP: "/qms/api/v1/user/validate-signup-token",
    FORGOT_PASSWORD: "/qms/api/v1/user/forgot-password",
    RESET_PASSWORD: "/qms/api/v1/user/reset-password",
    VALIDATE_FORGOT_PASSWORD_TOKEN:
      "/qms/api/v1/user/validate-forgot-password-token",
    VERIFY_EMAIL: "/qms/api/v1/auth/verify-email",
  },
  USERS: {
    SEND_REMINDER_EMAIL: (id: string, companyId: string) =>
      `/qms/api/v1/user/${id}/company/${companyId}/send-reminder`,
    CREATE_ARCHIVEST: "/qms/api/v1/user/onboard-archivist",
    CREATE_OWNER: "/qms/api/v1/user/onboard-owner",
    ACTIVE_DIRECTORY: "/qms/api/v1/user/active-directory/sharepoint",
    CREATE_USER: "/qms/api/v1/user",
    GET_ALL_USER: "/qms/api/v1/user",
    DELETE_USER: (id: string) => `/qms/api/v1/user/${id}`,
    UPDATE_USER: (id: string) => `/qms/api/v1/user/${id}`,
    GET_USER_DETAILS: (id: string) => `/qms/api/v1/user/${id}`,
    UPDATE_FOLDER_ASSIGNMENTS: (id: string) =>
      `/qms/api/v1/user/${id}/folder-assignments`,
    SEARCH_BY_EMAIL: (email: string) =>
      `/qms/api/v1/user/${email}/search-by-email`,
  },
  ROLES: {
    GET: "/qms/api/v1/role",
  },
  ELEMENT: {
    ELEMENTS: "/qms/api/v1/elements",
    QMS_ELEMENTS: "/qms/api/v1/qms-elements",
    FOLDERS: (elementId: string) => `/qms/api/v1/elements/${elementId}/folders`,
    DELETE_ELEMENT: (id: string) => `/qms/api/v1/qms-elements/${id}`,
    POST_DOCUMENT: (elementId: string) =>
      `/qms/api/v1/elements/${elementId}/documents`,
    QA_REGISTER: (elementId: string) =>
      `/qms/api/v1/elements/${elementId}/qa-register`,
    //Create a folder at the next allowed level and assign user, with MF logic (Other QMS)
    ASSIGN_FOLDER_WITH_MF: (elementId: string) =>
      `/qms/api/v1/elements/${elementId}/hierarchical-folder`,
    //Create a folder at the next allowed level and assign user, with MF logic (IO and TPU)
    ASSIGN_FOLDER_WITH_USER_MF: (elementId: string) =>
      `/qms/api/v1/elements/${elementId}/user-hierarchical-folder`,
  },
  SHAREPOINT: {
    CONFIG: "/qms/api/v1/sharepoint/config",
  },
  TEMPLATES: {
    GET: "/qms/api/v1/templates",
    CREATE: "/qms/api/v1/templates",
    UPDATE: (id: string) => `/qms/api/v1/templates/${id}`,
    DELETE: (id: string) => `/qms/api/v1/templates/${id}`,
  },
  DOCUMENTS: {
    GET_DOCUMENTS: `/qms/api/v1/my-documents`,
    GET_SINGLE_DOCUMENT: (documentId: string) =>
      `/qms/api/v1/documents/${documentId}`,
    MY_DOCUMENTS: (id: string) => `/qms/api/v1/folders/${id}/create-document`,
    GET_REVIEWERS: (documentId: string, reviewerType: string) =>
      `/qms/api/v1/documents/${documentId}/reviewers/${reviewerType}`,
    POST_DOCUMENT_STATUS: (documentId: string) =>
      `/qms/api/v1/documents/${documentId}/status`,
    GET_FOLDERS_DOCUMENT: (parentFolderId: string) =>
      `/qms/api/v1/document-types/${parentFolderId}/documents`,
    UPLOAD_RECORD: (documentId: string) =>
      `/qms/api/v1/documents/${documentId}/upload-record`,
    PUBLISH_RECORD: (documentId: string) =>
      `/qms/api/v1/documents/${documentId}/publish-record`,
    DOWNLOAD_PDF: (documentId: string) =>
      `/qms/api/v1/documents/${documentId}/download-pdf`,
    UP_VERSION_DOCUMENT: (recordId: string) =>
      `/qms/api/v1/records/${recordId}/up-version-document`,
    AUDIT_TRAIL: (documentId: string) =>
      `/qms/api/v1/documents/${documentId}/audit-trail`,
  },
  ASSIGNMENTS: {
    GET_ASSIGNMENTS: "/qms/api/v1/my-assignments",
  },
  FOLDERS: {
    GET_DOCUMENT_TYPE_FOLDER: (folderId: string) =>
      `/qms/api/v1/folders/${folderId}/document-types`,
    GET_HIERARCHY: (elementId: string) =>
      `/qms/api/v1/elements/${elementId}/folders-hierarchy`,
    GET_RECORDS_FOLDER: (folderId: string) =>
      `/qms/api/v1/folders/${folderId}/records`,
    UPLOAD_RECORD_IN_FOLDER: (folderId: string) =>
      `/qms/api/v1/folders/${folderId}/upload-record`,
    GET_MASTER_FILES: "/qms/api/v1/folders/master-files",
    GET_MASTER_FILE: (folderId: string) =>
      `/qms/api/v1/folders/master-files/${folderId}`,
    //Create Master File Folders For Users
    ASSIGN_FOLDER_TO_TEAM_MEMBER: (folderId: string) =>
      `/qms/api/v1/folders/${folderId}/add-member`,
  },
  MASTER_FOLDER: {
    REVIEW: (masterFolderId: string) =>
      `/qms/api/v1/master-folder/${masterFolderId}/review`,
    ARCHIVE: (masterFolderId: string) =>
      `/qms/api/v1/master-folder/${masterFolderId}/archive`,
    ASSIGNED_MASTER_FOLDERS: `/qms/api/v1/master-folder/assigned-master-folders`,
    ACTION: (reviewId: string) =>
      `/qms/api/v1/master-folder/${reviewId}/action`,
  },
  RECORDS: {
    MY_RECORDS: "/qms/api/v1/my-records",
    DOWNLOAD: (recordId: string) => `/qms/api/v1/records/${recordId}/download`,
    DELETE: (recordId: string) => `/qms/api/v1/records/${recordId}`,
    GET_ALL: "/qms/api/v1/records",
    WITHDRAW: (recordId: string) => `/qms/api/v1/records/${recordId}/withdraw`,
    FILE_NOTE: (recordId: string) =>
      `/qms/api/v1/records/${recordId}/file-notes`,
  },
  RECORDS_CATEGORIES: {
    GET_SECTIONS: "/qms/api/v1/record-categorization/sections",
    GET_CATEGORIES: (sectionId: string) =>
      `/qms/api/v1/record-categorization/categories?sectionId=${sectionId}`,
    GET_SUBCATEGORIES: (categoryId: string) =>
      `/qms/api/v1/record-categorization/subcategories?categoryId=${categoryId}`,
  },
  COMPANIES: {
    GET_COMPANIES: "/qms/api/v1/companies",
    GET_COMPANY: (companyId: string) => `/qms/api/v1/companies/${companyId}`,
    PATCH_COMPANY: (companyId: string) => `/qms/api/v1/companies/${companyId}`,
  },
  USER_GROUPS: {
    GET_USER_ASSIGNED_GROUP: "/qms/api/v1/usergroups/user",
    GET_USER_GROUPS: "/qms/api/v1/usergroups",
    GET_USER_GROUP_DETAILS: (groupId: string) =>
      `/qms/api/v1/usergroups/${groupId}`,
    CREATE_USER_GROUP: "/qms/api/v1/usergroups",
    UPDATE_USER_GROUP: (groupId: string) => `/qms/api/v1/usergroups/${groupId}`,
    DELETE_USER_GROUP: (groupId: string) => `/qms/api/v1/usergroups/${groupId}`,
    REMOVE_MEMBER: (groupId: string, memberId: string) =>
      `/qms/api/v1/usergroups/${groupId}/members/${memberId}`,
    GET_SUB_GROUPS: (groupId: string) =>
      `/qms/api/v1/usergroups/${groupId}/subgroups`,
  },
  SUBSCRIPTIONS: {
    GET_SUBSCRIPTIONS: "/qms/api/v1/subscriptions",
  },
  INVOICE: {
    GET_COMPANY_INVOICES: (companyId: string) =>
      `/qms/api/v1/invoices/company/${companyId}`,
    GET_INVOICE_DETAILS: (invoiceId: string) =>
      `/qms/api/v1/invoices/${invoiceId}`,
    UPDATE_INVOICE: (invoiceId: string) => `/qms/api/v1/invoices/${invoiceId}`,
    DOWNLOAD_INVOICE: (invoiceId: string) =>
      `/qms/api/v1/invoices/${invoiceId}/download`,
  },

  DASHBOARD_STATISTICS: {
    PUBLISHED_DOCUMENTS: "/qms/api/v1/dashboard/statistics/published-documents",
    DOCUMENTS_STATUS_OVERVIEW:
      "/qms/api/v1/dashboard/statistics/documents-status-overview",
    TASKS_ASSIGNED: "/qms/api/v1/dashboard/statistics/tasks-assigned",
    COMPANIES_OVERVIEW: "/qms/api/v1/dashboard/statistics/companies-overview",
    INVOICES_OVERVIEW: "/qms/api/v1/dashboard/statistics/invoices-overview",
  },
  REPORT_ISSUE: {
    POST: "/qms/api/v1/issues",
    GET_ALL: "/qms/api/v1/issues",
    PUT: (id: string) => `/qms/api/v1/issues/${id}/qa`,
    GET: (id: string) => `/qms/api/v1/issues/${id}`,
    GET_CATEGORIES: "/qms/api/v1/issues/categories",
    GET_SUB_CATEGORIES: (categoryId: string) =>
      `/qms/api/v1/issues/categories/${categoryId}/subcategories`,
  },
} as const;
